export const CATALOG_ITEM_USAGE_SCOPE_REPAIR = "repair";
export const CATALOG_ITEM_USAGE_SCOPE_WAREHOUSE = "warehouse";
export const CATALOG_ITEM_USAGE_SCOPE_INVOICE = "invoice";
export const CATALOG_ITEM_USAGE_SCOPE_CARGO = "cargo";

export const CATALOG_ITEM_BASE_TYPE_SERVICE = "service";

export const catalogItemUsageScopeOptions = [
  { value: CATALOG_ITEM_USAGE_SCOPE_REPAIR, label: "Ремонты" },
  { value: CATALOG_ITEM_USAGE_SCOPE_WAREHOUSE, label: "Склад" },
  { value: CATALOG_ITEM_USAGE_SCOPE_INVOICE, label: "Счета" },
  { value: CATALOG_ITEM_USAGE_SCOPE_CARGO, label: "Грузы" },
];

const usageScopeLabels = Object.fromEntries(
  catalogItemUsageScopeOptions.map((option) => [
    option.value,
    option.label,
  ])
);

const supportedUsageScopes = new Set(
  catalogItemUsageScopeOptions.map((option) => option.value)
);

/**
 * Нормализует области применения позиции каталога для формы.
 * По умолчанию новая позиция создается для ремонтов, но при редактировании
 * сохраняем все backend scope-ы, чтобы будущие склад/счета не терялись.
 * @param {Array|string|null|undefined} usageScopes - Значение из формы или API
 * @param {string|null|undefined} baseType - Тип позиции каталога
 * @returns {Array<string>}
 */
export const normalizeCatalogItemUsageScopes = (
  usageScopes,
  baseType = null
) => {
  if (baseType === CATALOG_ITEM_BASE_TYPE_SERVICE) {
    return [CATALOG_ITEM_USAGE_SCOPE_REPAIR];
  }

  const values = Array.isArray(usageScopes)
    ? usageScopes
    : [usageScopes].filter(Boolean);

  const normalized = values.filter((value) =>
    supportedUsageScopes.has(value)
  );

  return normalized.length
    ? [...new Set(normalized)]
    : [CATALOG_ITEM_USAGE_SCOPE_REPAIR];
};

/**
 * Форматирует области применения каталога для карточек и read-only UI.
 * @param {Array|string|null|undefined} usageScopes - Значение из API
 * @returns {string}
 */
export const formatCatalogItemUsageScopes = (usageScopes) =>
  normalizeCatalogItemUsageScopes(usageScopes)
    .map((scope) => usageScopeLabels[scope] || scope)
    .join(", ");
